import * as FindQuadraticCoefficientsTask from "./podtemat1_ogolna_types/FindQuadraticCoefficientsTask";
import * as FindVertexFromGeneralTask from "./podtemat1_ogolna_types/FindVertexFromGeneralTask";
import * as DeltaAndZerosCountTask from "./podtemat1_ogolna_types/DeltaAndZerosCountTask";
import * as FindRootsFromGeneralTask from "./podtemat1_ogolna_types/FindRootsFromGeneralTask";
import * as PlotQuadraticSpecialPointsTask from "./podtemat1_ogolna_types/PlotQuadraticSpecialPointsTask";

const TYPES = {
  FindQuadraticCoefficientsTask,
  FindVertexFromGeneralTask,
  DeltaAndZerosCountTask,
  FindRootsFromGeneralTask,
  PlotQuadraticSpecialPointsTask, // 5)
};

export function generateTasks() {
  return [
    TYPES.FindQuadraticCoefficientsTask.generateTask(), // 1) a,b,c
    TYPES.FindVertexFromGeneralTask.generateTask(),     // 2) p,q
    TYPES.DeltaAndZerosCountTask.generateTask(),        // 3) Δ + liczba miejsc zerowych
    TYPES.FindRootsFromGeneralTask.generateTask(),      // 4) x1, x2
    TYPES.PlotQuadraticSpecialPointsTask.generateTask() // 5) x1, x2, (p,q), y0 + wykres
  ];
}

export function renderTask(task)        { const m=TYPES[task.type]; return m?m.renderTask(task):null; }
export function renderInput(t,u,c,d)    { const m=TYPES[t.type];    return m?m.renderInput(t,u,c,d):null; }
export function checkAnswer(t,u)        { const m=TYPES[t.type];    return m?m.checkAnswer(t,u):false; }
export function renderAnswer(t)         { const m=TYPES[t.type];    return m?m.renderAnswer(t):null; }
export function renderExplanation(t)    { const m=TYPES[t.type];    return m?m.renderExplanation(t):null; }
export function renderUserAnswer(t,u)   { const m=TYPES[t.type]; return m&&m.renderUserAnswer?m.renderUserAnswer(t,u):null; }

export default {
  generateTasks, renderTask, renderInput, checkAnswer, renderAnswer, renderExplanation, renderUserAnswer,
};
